import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Typography } from "@material-ui/core";
const styles = (theme) => ({});

function InstructorRefreshDialog(props) {
    
	return (
		<>
            <Dialog 
                open={props.open} 
                onClose={() => {
                    props.openCtl(false);
                }}
            >
                <DialogTitle>
                    <Typography style={{ fontSize: "1.3rem" }} color="primary">
                        Refresh Notice
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        If you currently have WebClicker open on multiple devices, you may need to refresh on your other devices to see your changes.
                    </Typography>
                </DialogContent>
                <DialogActions
                    style={{justifyContent: "center"}}
                >
                    <Button 
                        color="primary" 
                        onClick={() => {
                            props.openCtl(false);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
		</>
	);
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(InstructorRefreshDialog))));
